import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HjezlyLogo from './HjezlyLogo';

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="bg-neutral-800 dark:bg-neutral-950 text-neutral-400 dark:text-neutral-300 p-8 transition-colors">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0 flex flex-col items-center md:items-start">
          <div className="mb-2">
            <HjezlyLogo size="md" variant="full" className="text-white dark:text-neutral-100" />
          </div>
          <p className="text-sm">© {new Date().getFullYear()} Hjezly. All rights reserved.</p>
        </div>
        <div className="text-center md:text-right">
          <h4 className="font-semibold text-white dark:text-neutral-100 mb-2">{t('footer.title')}</h4>
          <button
            onClick={() => navigate('/login')}
            className="text-neutral-300 dark:text-neutral-400 hover:text-white dark:hover:text-neutral-100 hover:underline transition-colors"
          >
            {t('footer.link')}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;